import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CfiMatTableFilterStateService {

  saveFilterState<T>(key: string, filterState: T): void {
    sessionStorage.setItem(key, JSON.stringify(filterState));
  }

  getFilterState<T>(key: string): T | null {
    const filterState = sessionStorage.getItem(key);
    return filterState ? JSON.parse(filterState) : null;
  }

  clearFilterState(key: string): void {
    sessionStorage.removeItem(key);
  }

  /**
   * Marks a field as cleared in the session storage. 
   * This can be used to track if a specific field has been cleared by the user.
   * @param key The unique key for the filter state.
   * @param fieldName The name of the field to mark as cleared.
   */
  markFieldCleared(key: string, fieldName: string): void {
    sessionStorage.setItem(this.getClearedMarkerKey(key, fieldName), '1');
  }

  /**
   * Clears the cleared mark for a specific field in the session storage.
   * @param key The unique key for the filter state.
   * @param fieldName The name of the field to clear the mark for.
   */
  clearFieldClearedMark(key: string, fieldName: string): void {
    sessionStorage.removeItem(this.getClearedMarkerKey(key, fieldName));
  }

  /**
   * Checks if a specific field has been marked as cleared in the session storage.
   * @param key The unique key for the filter state.
   * @param fieldName The name of the field to check.
   * @returns True if the field is marked as cleared, false otherwise.
   */
  isFieldClearedMarked(key: string, fieldName: string): boolean {
    return sessionStorage.getItem(this.getClearedMarkerKey(key, fieldName)) === '1';
  }

  /**
   * Generates a unique key for marking a field as cleared in the session storage.
   * @param key The unique key for the filter state.
   * @param fieldName The name of the field.
   * @returns A string that can be used as a key in session storage.
   */
  private getClearedMarkerKey(key: string, fieldName: string): string {
    return `${key}:${fieldName}:cleared`;
  }
}